module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_2_B.30aa91ba.png";